import { Config } from '@flowwai-frontend/bps-officer-web/env-config'

export const enableLoginWithUsername = Config.LOGIN_MODE === 'USERNAME'
